<app-dialog-heading [heading]="'Transactions'"></app-dialog-heading>

  <ng-container *ngIf="adminStatus == 'MEDSCHEME'">
    <form class="date-range">
      <app-element-date-range
        class="flex-grow-1"
        label="Date Range"
        [defaultStartDate]="dateRange?.start"
        [defaultEndDate]="dateRange?.end"
        (dateRangeChanged)="onDateRangeChanged($event)">
      </app-element-date-range>

      <button mat-raised-button color="primary" [disabled]="isSearchDisabled" [matTooltip]="isSearchDisabled? 'Choose a start date and end date':''"
      class="search-button" (click)="searchByDate()">Search</button>
    </form>
  </ng-container>

  <ng-container *ngIf="isDataExist;
                  then showTransactionDataTable else emptyPlaceHolder"></ng-container>
  <ng-template #showTransactionDataTable>
    <div class="mat-elevation-z8 table-container">
      <table class="w-100" mat-table matSort [dataSource]="transactionsDataSource"
             #MatSortTransactionStep="matSort">
        
        <ng-container [matColumnDef]="tableColumns.TransactionId">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Claim ID</th>
          <td *matCellDef="let row" mat-cell>{{row.transactionId}}</td>
        </ng-container>
        
        <ng-container [matColumnDef]="tableColumns.TransactionType">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Type</th>
          <td *matCellDef="let row" mat-cell>{{row.transactionType}}</td>
        </ng-container>
        
        <ng-container [matColumnDef]="tableColumns.ProviderName">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Provider</th>
          <td *matCellDef="let row" mat-cell>{{row.providerName}}</td>
        </ng-container>
        
        <ng-container [matColumnDef]="tableColumns.ReceiveDate">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Date Received</th>
          <td *matCellDef="let row" mat-cell>{{row.receiveDate | date: dateFormat}}</td>
        </ng-container>
        
        <ng-container [matColumnDef]="tableColumns.EncounterStartDate">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Encounter Date</th>
          <td *matCellDef="let row" mat-cell>{{row.encounterStartDate | date: dateFormat}}</td>
        </ng-container>
        
        <ng-container [matColumnDef]="tableColumns.AssessingStatus">
          <th *matHeaderCellDef mat-header-cell mat-sort-header >Assessing Status</th>
          <td *matCellDef="let row" mat-cell>{{row.assessingStatus}}</td>
        </ng-container>
        
        <ng-container [matColumnDef]="tableColumns.PayTo">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Pay</th>
          <td *matCellDef="let row" mat-cell
              [matTooltip]="(row.transactionType == ClaimType.Claim ? row.payTo : null)">
            {{(row.transactionType == ClaimType.Claim ? ClmFunctions.getPayToAcronym(row?.payTo) : null)}}
          </td>
        </ng-container>
        
        <ng-container [matColumnDef]="tableColumns.AmountClaimed">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Claimed Amount</th>
          <td *matCellDef="let row" mat-cell>{{row.amount | number: '.2'}}</td>
        </ng-container>
        
        <ng-container [matColumnDef]="tableColumns.BenefitAmount">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>Benefit Amount</th>
          <td *matCellDef="let row" mat-cell>{{row.benefitAmount | number: '.2'}}</td>
        </ng-container>
        
        <tr mat-header-row *matHeaderRowDef="transactionsDisplayedColumns; sticky: true;"></tr>
        <tr mat-row *matRowDef="let row; columns: transactionsDisplayedColumns;"></tr>
      </table>
      
      <ng-container *ngIf="adminStatus == 'PHA'">
        <mat-paginator  #transactionsPaginator (page)="pageChanged($event)"
                     [length]="transactionsTableControl.length" [pageIndex]="0"
                     [pageSizeOptions]="transactionsTableControl.pageSizeOptions"
                     [pageSize]="transactionsTableControl.pageSize">
      </mat-paginator>

      </ng-container>
      
    </div>
  </ng-template>
  
  <ng-template #emptyPlaceHolder>
    <div class="text-center">
      <label class="column-label claim-column-label">No transaction data</label>
    </div>
  </ng-template>